import {
  getUrlParameter,
  adjustCWPMappedUrl,
} from '../../../global/data/url.js'

export default function updateViewAllHoldingsLink() {
  const cusip = getUrlParameter('cusip')
  const link = document.querySelector('.js-full-holdings-link')

  if (link) {
    const mappedUrl = adjustCWPMappedUrl('full-holdings', cusip)

    link.setAttribute('href', `${mappedUrl}`)
  }
}
